export default __webpack_public_path__ + "static/media/Fasthand-Regular.e7c16c0e.woff2";